import { MapClickToolConfigModel, MapClickToolModel, MapClickEvent } from '../../models';
import { Observable, Subject, takeUntil } from 'rxjs';
import { OpenLayersEventManager } from '../open-layers-event-manager';
import { CesiumEventManager } from '../cesium-map/cesium-event-manager';
import { OlMapScaleHelper } from '../../helpers/ol-map-scale.helper';

export class OpenLayersMapClickTool implements MapClickToolModel {

  private enabled = new Subject();

  constructor(
    public id: string,
    private _toolConfig: MapClickToolConfigModel,
    private eventManager: OpenLayersEventManager,
    private cesiumEventManager: CesiumEventManager,
  ) {}

  private mapClickSubject: Subject<MapClickEvent> = new Subject<MapClickEvent>();
  public mapClick$: Observable<MapClickEvent> = this.mapClickSubject.asObservable();
  public isActive = false;

  public destroy(): void {
    this.disable();
    this.mapClickSubject.complete();
  }

  public disable(): void {
    this.enabled.next(null);
    this.enabled.complete();
    this.isActive = false;
  }

  public enable(): void {
    this.enabled = new Subject();
    this.cesiumEventManager.onMap3dClick$()
      .pipe(takeUntil(this.enabled))
      .subscribe(evt => {
        this.mapClickSubject.next({
          mapCoordinates: [ evt.position.x, evt.position.y ],
          mouseCoordinates: [ evt.mouseCoordinates.x, evt.mouseCoordinates.y ],
          cesiumFeatureInfo: evt.featureInfo,
        });
      });
    this.eventManager.onMapClick$()
      .pipe(takeUntil(this.enabled))
      .subscribe(click => {
        const { scale, resolution } = OlMapScaleHelper.getResolutionAndScale(click.map.getView());
        this.mapClickSubject.next({
          mapCoordinates: [ click.coordinate[0], click.coordinate[1] ],
          mouseCoordinates: [ click.pixel[0], click.pixel[1] ],
          pointerType: click.originalEvent.pointerType,
          resolution,
          scale,
        });
      });
    this.isActive = true;
  }

}
